import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState} from "react";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(JSON.parse(localStorage.getItem("isLoggedIn")));
  const queryClient = useQueryClient()

  const signIn = (data) => {
    setIsLoggedIn(true);
    localStorage.setItem("ttf-token", data.data.accessToken);
    localStorage.setItem("isLoggedIn", JSON.parse(true));
  };

 

  const signOut = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("ttf-token");
    setIsLoggedIn(false);
    //queryClient.removeQueries()
  };

  return (
  
    <AuthContext.Provider
      value={{ isLoggedIn, signIn, signOut, }}
    >
      {children}
    </AuthContext.Provider>
  );
};
